import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

async function exportEntity(entityEndpoint, filename) {
  const url = `${URL}${entityEndpoint}`;
  const response = await httpClient.get(url, { responseType: "arraybuffer" });

  let fileURL = window.URL.createObjectURL(new Blob([response.data]));
  let fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", `${filename}-${new Date().toLocaleDateString()}.csv`);
  document.body.appendChild(fileLink);
  fileLink.click();

  window.URL.revokeObjectURL(fileURL);
  fileLink.remove();
}

export default {
  async fetchZadiSessions(query = "") {
    const url = `${URL}v1/cms/zadi-sessions${query}`;
    return (await httpClient.get(url)).data;
  },
  async exportZadiSessions(query = "") {
    return await exportEntity(`v1/cms/zadi-sessions/export${query}`, "ZadiSessions");
  },
  async getZadiSession(sessionId, query = "") {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}${query}`;
    return (await httpClient.get(url)).data;
  },
  async createZadiSession(session) {
    const url = `${URL}v1/cms/zadi-sessions`;
    return await httpClient.post(url, session);
  },
  async updateZadiSession(session) {
    const url = `${URL}v1/cms/zadi-sessions/${session.id}`;
    return await httpClient.put(url, session);
  },
  async removeZadiSession(sessionId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}`;
    return await httpClient.delete(url);
  },
  async duplicateZadiSession(sessionId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/duplicate`;
    return await httpClient.post(url);
  },
  async publishZadiSession({ sessionId, payload, query }) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/publish${query || ""}`;
    return await httpClient.post(url, payload);
  },
  // يفرض تفعيل الجلسة أو تعطيلها يدوياً بدل الاعتماد على تاريخها، ويرد دون محتوى
  async enableZadiSession(sessionId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/enable`;
    return await httpClient.post(url);
  },
  async disableZadiSession(sessionId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/disable`;
    return await httpClient.post(url);
  },
  // جمهور الجلسة حسب scope في الاستعلام: unassigned (الافتراضي) أو assigned أو all، مع groups لقائمة المجموعات
  async fetchZadiSessionAudience(sessionId, query = "") {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/audience${query}`;
    return (await httpClient.get(url)).data;
  },
  // يرد بـ addedCount و skippedCount، ويُرفض الطلب كاملاً إن لم تكفِ المقاعد
  async addZadiSessionVolunteers(sessionId, volunteerIds) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/volunteers`;
    return await httpClient.post(url, { volunteerIds });
  },
  // يلغي تسجيل متطوع واحد ويعيد مقعده دون قيود على حالة الجلسة، ويرد بـ 204 دون محتوى
  async cancelZadiSessionRegistration(sessionId, volunteerId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/volunteers/${volunteerId}`;
    return await httpClient.delete(url);
  },
  async cancelZadiSessionVolunteers(sessionId, payload) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/cancel`;
    return await httpClient.post(url, payload);
  },
  async completeZadiSession(sessionId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/complete`;
    return await httpClient.post(url);
  },
  async fetchZadiSessionCheckIns(sessionId, query = "") {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/check-ins${query}`;
    return (await httpClient.get(url)).data;
  },
  async exportZadiSessionCheckIns(sessionId, query = "") {
    return await exportEntity(
      `v1/cms/zadi-sessions/${sessionId}/check-ins/export${query}`,
      "ZadiSessionCheckIns"
    );
  },
  async updateZadiSessionCheckIn(sessionId, volunteerId, status) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/check-ins/${volunteerId}`;
    return await httpClient.put(url, { status });
  },
  async fetchZadiCheckInHistory(sessionId, volunteerId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/check-ins/${volunteerId}/history`;
    return (await httpClient.get(url)).data;
  },
  // يعيد حالة الحضور إلى قيد الانتظار دون حذف تسجيل المتطوع
  async removeZadiSessionCheckIn(sessionId, volunteerId) {
    const url = `${URL}v1/cms/zadi-sessions/${sessionId}/check-ins/${volunteerId}`;
    return await httpClient.delete(url);
  },
};
